import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, delay, map, switchMap, tap } from 'rxjs/operators';
import { AbstractAuthEventService } from '../abstract-auth-event/abstract-auth-event.service';

const NO_AUTH_HEADER = 'No-Auth';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private authServuce: AuthService, private authEventService: AbstractAuthEventService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.get(NO_AUTH_HEADER)) {
      return next.handle(req.clone({
        headers: req.headers.delete(NO_AUTH_HEADER.toLowerCase())
      }));
    }

    return from(this.authServuce.getAccessTokenAsync()).pipe(
      map((token) => ({ request: this.getRequestWithAuthorizeHeader(token, req), token })),
      switchMap((aggregated) =>
        next.handle(aggregated.request).pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.status === 401) {
              return of({}).pipe(
                tap(() => {
                  try { // So it does not fail if any error occures during logging
                    this.authEventService.trackLogoutAfterUnauthorized({
                      requestUrl: aggregated.request.urlWithParams,
                      tokenExists: !!aggregated.token,
                      authorizationHeader: aggregated.request.headers.get('Authorization')?.substring(0, 20) || null,
                      token: aggregated.token?.substring(0, 20) || null,
                      message: err.message,
                      error: err.error,
                      anecdotesTraceId: err.headers.get(err.headers.keys().find((key) => key.toLowerCase() === 'anecdotes-trace-id'))
                    });
                  } catch {
                    // nothing
                  }
                }
                ),
                // this is because signout might happen before event is sent and this causes the event to be not sent
                delay(1000),
                // tap(() => this.authServuce.signOutAsync(false)), // temporarily disabled
                switchMap(() => throwError(err))
              );
            }

            return throwError(err);
          })
        )
      )
    );
  }

  private getRequestWithAuthorizeHeader(token: string, originalReq: HttpRequest<any>): HttpRequest<any> {
    return originalReq.clone({
      headers: originalReq.headers.append('Authorization', `Bearer ${token}`),
    });
  }
}
